import {Box} from '@chakra-ui/react'
import Header from './Header'
import Content from './Content'

const VocabularyResult = () => {
  return (
    <Box minH={'100vh'} bg={'#F9FAFB'}>
      <Header />
      <Content />
    </Box>
  )
}

export default VocabularyResult
